import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Debtors from '../views/Debtors.vue'
import VatNumbers from '../views/VatNumbers.vue'
import Cars from '../views/Cars.vue'
import Users from '../views/Users.vue'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        showInMenu: true
    },
    {
        path: '/debtors',
        name: 'Debtors',
        component: Debtors,
        showInMenu: true
    },
    {
        path: '/vat-numbers',
        name: 'VatNumbers',
        component: VatNumbers,
        showInMenu: true
    },
    {
        path: '/cars',
        name: 'Cars',
        component: Cars,
        showInMenu: false
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        showInMenu: true
    }
];

const router = new VueRouter(
    {
        mode: 'hash',
        base: process.env.BASE_URL,
        routes
    }
);

export default router
